export class LoginService {
    constructor(httpService, authorizationService) {
        this.httpService = httpService;
        this.authorizationService = authorizationService;
    }
    async login(email, password) {
        const response = await this.httpService.post('login', { email, password });
        if (!response.ok) {
            throw new Error('Ha ocurrido un error al efectuar el login.');
        }
        const { access_token, error } = await response.json();
        if (!access_token || error) {
            return { error: this.mapLoginError(error) };
        }
        this.authorizationService.setToken(access_token);
    }
    mapLoginError(error) {
        if (error === 'ACCOUNT_CONTRACT_EXPIRED') {
            return LoginService.ACCOUNT_DEACTIVATED_MESSAGE;
        }
        return typeof error === 'string' && error.trim()
            ? error
            : 'Parece que los datos de acceso no son válidos.';
    }
}
LoginService.ACCOUNT_DEACTIVATED_MESSAGE = 'La cuenta ha sido desactivada. Contacta con soporte.';
